<template>
  <v-container>
      <v-layout row>



          <v-flex xs12 sm6 offset-sm3>
                        <div class="message">{{ 'DOBRO DOŠLI! ' }}</div>
                        
                         <div class="message1">{{ ' Izaberite odgovarajuće dugme za nastavak' }}</div>
            <v-card width="500" class="mx-auto mt-15">
              <v-card-text>
                
                <v-row justify="space-around">
                <v-col cols="12" md="5">
                <v-btn @click="izlazne()"> Izlazne fakture </v-btn>
                <br/> 
                <br/>  
                                                         
                <v-btn @click="ulazne()"> Ulazne fakture </v-btn>
                  
                    </v-col>
                    </v-row>            
             
              </v-card-text>
            </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
export default {
   name: "WelcomePage",
  components: {
  },
  data()
  {
      return{
      }
  },
  created() {
    this.logout()
  },
  methods: {

    login() {
      if(this.$config.AuthConfigType == 'AD' && !this.isLoggedIn) {
        this.$store.dispatch('login', {user: {}, authType: this.$config.AuthConfigType})
        .then(() => {
        })
        .catch(err => {
          this.message = err
          console.log(err)
        })
      }
    },
    logout() {
      this.$store.dispatch('logout')
    },
    izlazne: function() {
          this.login()  
          this.$router.push({ name: 'Home', replace: true})
        
        .catch(err => {
          this.message = err
          console.log(err)
        })
      },

     ulazne: function() {
            // this.login()  
          //this.$router.push({ URL: 'InvoiceForm', replace: true})
          // http://localhost:5001/
        //  axios.defaults.baseURL = 'http://localhost:5001/' //produkcija
         // this.$config.push({ name: 'UCDynamicFormsLink', replace: true})
         
       // window.location = this.$config.UCDynamicFormsLink
        console.log(this.$config.UCDynamicFormsLink);

        window.location = this.$config.UCDynamicFormsLink
      }, 

     /* openLink() {
        console.log(this.$config.UCDynamicFormsLink);
        window.location = this.$config.UCDynamicFormsLink;
              } 
  */
  }
}

</script>

<style scoped>
.message {
  text-align: center;
  margin-top: 50px;
  color: black;
  font-size: 200%;
  width: 1000;

}
.message1 {
  margin-top: 0px;
  color:black;
  font-size: 180%;
  text-align: center;
  width: 1000;

}
</style>